<template>
  <v-card class="mx-auto">
    <v-img class="align-end text-white" height="140" src="/cpm.webp" contain />
    <v-card-text>
      <HelpFormInput
        v-model="total"
        label="Total Budget ($)"
        placeholder="Total Budget"
        help-text="The total budget for the campaign."
        :hint="'Budget for the entire campaign.'"
        :rules="rules.total"
        @update:model-value="
          (v) =>
            onUpdate({
              ...modelValue,
              budget: {
                ...(modelValue.budget || {}),
                total: v,
              },
            })
        "
      />

      <HelpFormInput
        v-model="daily"
        label="Daily Budget ($)"
        placeholder="Daily Budget"
        help-text="The daily budget for the campaign."
        :hint="'Budget for 24 hours.'"
        :rules="rules.daily"
        @update:model-value="
          (v) =>
            onUpdate({
              ...modelValue,
              budget: {
                ...(modelValue.budget || {}),
                daily: v,
              },
            })
        "
      />

      <HelpFormInput
        v-model="cpm"
        label="Cost per Mile ($)"
        placeholder="Cost per Mile"
        :hint="'This value is maximum bid for 1000 impressions. '"
        help-text="CPM allows to define the cost per 1000 impressions. Higher CPM allows to win more impressions."
        :rules="rules.cpm"
        @update:model-value="
          (v) =>
            onUpdate({
              ...modelValue,
              budget: {
                ...(modelValue.budget || {}),
                cpm: v,
              },
            })
        "
      />
      <HelpFormInput
        v-model="frequencyCap"
        label="Frequency Cap "
        placeholder="Frequency Cap"
        hint="Impressions/User/24h"
        help-text="This value is maximum number of impressions per user in 24 hours."
        :rules="rules.frequencyCap"
        @update:model-value="
          (v) =>
            onUpdate({
              ...modelValue,
              settings: {
                ...(modelValue.settings || {}),
                frequencyCap: v,
              },
            })
        "
      />
    </v-card-text>
  </v-card>
</template>
    
    
    <script>
import HelpFormInput from "../../atoms/common/inputs/HelpFormInput.vue";

export default {
  components: {
    HelpFormInput,
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["next", "update:modelValue"],
  data() {
    return {
      name: null,
      total: 0,
      daily: 0,
      cpm: 0,
      frequencyCap: 0,

      rules: {
        total: [
          (v) => !!v || "Total Budget is required",
          (v) => v > 0 || "Total Budget must be greater than 0",
        ],
        daily: [
          (v) => !!v || "Daily Budget is required",
          (v) => v > 0 || "Daily Budget must be greater than 0",
          (v) => Number(v) < Number(this.total) || "Daily Budget must be less than Total Budget",
        ],
        cpm: [
          (v) => !!v || "CPM is required",
          (v) => v > 0 || "CPM must be greater than 0",
        ],
        frequencyCap: [
          (v) => !!v || "Frequency Cap is required",
          (v) => /^[0-9]+$/.test(v) || "Frequency Cap must be a number",
          (v) => v < 50 || "Frequency Cap must be less than 50",
          (v) => v > 0 || "Frequency Cap must be greater than 0",
        ],
      },
    };
  },
  computed: {},

  created() {},
  methods: {
    onUpdate(value) {
      this.$emit("update:modelValue", value);
    },
  },
};
</script>